import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  skeletonRoot: {
    marginTop: Spacings.s24,
  },
  skeleton: {
    height: 270,
    width: '100%',
    borderRadius: CornerRadius.r12,
    marginBottom: Spacings.s24,
  },
});

export default useStyles;
